export const TYPE_FILTER_RESCHEDULE_LINE = "reschedule_line";
export const TYPE_FILTER_RESCHEDULE_OPERATION = "reschedule_operation";
export const TYPE_FILTER_LINE = "line";
export const TYPE_FILTER_MATERIAL = "material";
export const TYPE_FILTER_ORDER = "order";
export const TYPE_FILTER_ORDER_INSIGHT_TYPE = "order_insight_type";
export const TYPE_FILTER_REWORK_ORDERS = "filter_rework_orders";
export const TYPE_FILTER_PLANNING_RESULT = "planning_result_filter";
export const TYPE_FILTER_CUSTOM = "custom";

export const TypeFilterValues = {
    [TYPE_FILTER_RESCHEDULE_LINE]: TYPE_FILTER_RESCHEDULE_LINE,
    [TYPE_FILTER_RESCHEDULE_OPERATION]: TYPE_FILTER_RESCHEDULE_OPERATION,
    [TYPE_FILTER_LINE]: TYPE_FILTER_LINE,
    [TYPE_FILTER_MATERIAL]: TYPE_FILTER_MATERIAL,
    [TYPE_FILTER_ORDER]: TYPE_FILTER_ORDER,
    [TYPE_FILTER_ORDER_INSIGHT_TYPE]: TYPE_FILTER_ORDER_INSIGHT_TYPE,
    [TYPE_FILTER_REWORK_ORDERS]: TYPE_FILTER_REWORK_ORDERS,
    [TYPE_FILTER_PLANNING_RESULT]: TYPE_FILTER_PLANNING_RESULT,
    [TYPE_FILTER_CUSTOM]: TYPE_FILTER_CUSTOM,
} as const;

export type SelectOptionItem = {
    label: string;
    value: string;
};
